<template>
  <section class="section-8 grey wrapper">
    <div class="hd hd-flip">
      <h2 class="title">
        线下学员评价
      </h2>
    </div>

    <div class="content">
      <vue-slick-carousel
        v-if="sliderList.length > 0"
        ref="carousel"
        v-bind="slickSettings"
      >
        <div
          v-for="(item, i) in sliderList"
          :key="i"
        >
          <div
            v-for="(sub, subIndex) in item"
            :key="i + '-' + subIndex"
            class="content-item"
          >
            <div class="content-item__thumb">
              <img :src="sub.avatar">
            </div>
            <h5>{{ sub.name }}</h5>
            <p>{{ sub.content }}</p>
          </div>
        </div>
      </vue-slick-carousel>

      <span
        class="btn-prev"
        @click="onPrev"
      />
      <span
        class="btn-next"
        @click="onNext"
      />
    </div>
    <btn-contact name="B页-线下学员评价-预约咨询" />
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import { getComments } from '@/api';
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
    VueSlickCarousel,
  },
  data() {
    return {
      list: [],
      current: 0,
      pageSize: 4,
      slickSettings: {
        dots: true,
        infinite: true,
        arrows: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      },
    };
  },
  computed: {
    sliderList() {
      const nums = 4;
      const len = this.list.length;
      const splitNums = len % nums === 0 ? len % nums : Math.ceil(len / nums);
      const list = [];

      for (let i = 0; i < splitNums; i++) {
        const temp = this.list.slice(i * nums, i * nums + nums);
        list.push(temp);
      }

      return list;
    },
  },
  mounted() {
    getComments().then((res) => {
      this.list = res;
    });
  },
  methods: {
    onCurrentChange(i) {
      const index = i > Math.ceil(this.list.length / this.pageSize) - 1 ? 0 : i < 0 ? Math.ceil(this.list.length / this.pageSize) - 1 : i;
      this.current = index;
      this.$refs.carousel.goTo(index);
    },
    onPrev() {
      this.$refs.carousel.prev();
    },
    onNext() {
      this.$refs.carousel.next();
    },
  },
};
</script>

<style lang="scss" scoped>
.section-8 {
  padding-top: percentage(112px / $deviceWidth);
  padding-bottom: percentage(50px / $deviceWidth);

  .title {
    margin-right: percentage(214px / $deviceWidth);
    width: percentage(340px / $deviceWidth);
    padding-top: percentage(140px / $deviceWidth);
  }

  .content {
    position: relative;
    $contentWidth: 1440px;
    margin: percentage(64px / $deviceWidth) auto;
    width: percentage($contentWidth / $deviceWidth);
    text-align: left;

    &-item {
      position: relative;
      margin-bottom: percentage(64px / $contentWidth);
      padding-left: percentage(138px / $contentWidth);

      &__thumb {
        position: absolute;
        left: 0;
        top: 0;
        width: percentage(108px / $contentWidth);
        padding-top: percentage(108px / $contentWidth);
        border-radius: 100%;
        overflow: hidden;

        img {
          @include center();
          width: 100%;
          height: 100%;
        }
      }

      h5 {
        position: relative;
        margin: 0 auto percentage(12px / $contentWidth);
        font-size: 22px;
        color: #3A4047;
        line-height: 22px;
        @include ellipse(1);

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
          margin-bottom: percentage(-32px / 480px);
          width: 72px;
          height: 3px;
          background-color: #3773CB;
        }
      }

      p {
        font-size: 20px;
        line-height: 28px;
        color: rgba(58, 64, 71, 0.8);
      }
    }

    .btn-prev, .btn-next {
      position: absolute;
      top: 50%;
      z-index: 3;
      width: percentage(64px / $contentWidth);
      padding-top: percentage(64px / $contentWidth);
      cursor: pointer;
      background: url("~assets/btn-arrow.png") center/contain no-repeat;

      @include hdpi() {
        background-image: url("~assets/btn-arrow@2x.png");
      }

      &:hover {
        background: url("~assets/btn-arrow-active.png") center/contain no-repeat;

        @include hdpi() {
          background-image: url("~assets/btn-arrow-active@2x.png");
        }
      }
    }

    .btn-prev {
      left: percentage(-120px / $contentWidth);
      transform: translate(0, -50%);
    }

    .btn-next {
      right: percentage(-120px / $contentWidth);
      transform: translate(0, -50%) rotate(180deg);
    }
  }

  ::v-deep .slick-dots {
    display: none !important;
  }

  @include mediaWidth(1440px) {
    .content {
      &-item {
        padding-left: 75px;
        &__thumb {
          width: 60px;
          height: 60px;
          padding-top: 0;
        }
        h5 {
          font-size: 18px;
        }
        p {
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      width: 85%;

      &-item {
        h5 {
          font-size: 18px;
        }
        p {
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
  @include mediaWidth(#{$mbWidth}) {
    padding-top: percentage(64px / $mbWidth);
    padding-bottom: percentage(50px / $mbWidth);
    .title {
      width: percentage(309px / $mbWidth);
      padding-top: percentage(86px / $mbWidth);
    }
    .content {
      width: 100%;
      margin: percentage(40px / $mbWidth) auto percentage(92px / $mbWidth);

      &-item {
        width: percentage(680px / $mbWidth);
        margin: 0 auto percentage(44px / 680px);
        padding-left: 0;
        &__thumb {
          position: absolute;
          top: 0;
          left: 0;
          width: 45px;
          height: 45px;
          padding-top: 0;
        }
        h5 {
          margin-bottom: percentage(20px / 680px);
          padding-left: 60px;
          font-size: 16px;
          line-height: 45px;
        }
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
      .btn-prev, .btn-next {
        display: none;
      }
    }
    ::v-deep .slick-dots {
      display: block !important;

      button {
        &::before {
          content: "";
          width: 6px;
          height: 6px;
          border: 2px solid #3A4047;
          opacity: .4;
          border-radius: 100%;
        }
      }

      li.slick-active {
        button {
          &::before {
            opacity: 1;
            border-color: #3773CB;
          }
        }
      }
    }
  }
  @include mediaWidth(528px) {
    .content {
      &-item {
        &__thumb {
          width: 30px;
          height: 30px;
        }
        h5 {
          font-size: 15px;
          padding-left: 40px;
          line-height: 30px;
        }
      }
    }
  }
}
/* 下往上淡入，上往下淡出 */
/* to-up */
.fade-leave-active,
.fade-enter-active {
  transition: all 0.3s;
}
.fade-enter {
  opacity: 0;
  transform: translateX(20px);
}
.fade-leave-to {
  display: none;
  position: absolute;
  opacity: 0;
  transform: translateX(-20px);
}
</style>
